<!--
    @分页组件
-->
<template>
    <div class="my_pag">
        <el-pagination background :layout="optionsCom.layout" :total="optionsCom.total" :page-sizes="optionsCom.pageSizes"
			:page-size="optionsCom.pageSize" :current-page="optionsCom.pageIndex" @size-change="sizeChangeHandle"
			@current-change="currentChangeHandle">
		</el-pagination>
    </div>
</template>
<script>
export default {
    data(){
        return{}
    },
    props:{
		options:{
			type:Object,
			default:function(){
				return {}
			}
		}
	},
	computed:{
		optionsCom(){
			return Object.assign({
				layout:"total, sizes, prev, pager, next, jumper",
				total:0,
				pageSize:10,
				pageIndex:1,
				pageSizes:[10, 20, 50]
			},this.options)
		}
	},
    methods:{
		// 每页长度改变
        sizeChangeHandle(value){
            this.$emit('sizechange',value);
        },
        // 当前页改变
        currentChangeHandle(value){
            this.$emit('pagechange',value);
        },
	}
}
</script>

<style lang="scss" scoped>
.my_pag{
	/deep/ .el-input.el-pagination__editor .el-input__inner{
		line-height: 28px;
	}
	.el-pagination{
		padding: 2px 5px 10px 5px;
		text-align: right;
		/deep/ .el-pager{
			.number{
				font-weight: normal;
			}
			li:not(.disabled).active{
				background-color: #1890FF;
			}
		}
	}
}
</style>
